import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import useKeydownEventListener from 'hooks/useKeydownEventListener'
import React from 'react'
import styled, { css } from 'styled-components'

import { modalColors } from 'theme/modal/colors'

export interface ModalProps<T = any> {
  id?: string
  onDismiss?: () => void
  data?: T
  disableClose?: boolean
  sizeMode?: ModalSizeModeEnum
}

export enum ModalSizeModeEnum {
  Full,
  Auto,
}

const AlchemyModal: React.FC<ModalProps & BoxProps & { colorTheme: keyof typeof modalColors }> = ({
  id,
  onDismiss,
  children,
  colorTheme,
  disableClose,
  sizeMode = ModalSizeModeEnum.Auto,
  className,
  ...props
}) => {
  const handleOnDismiss = () => {
    if (onDismiss && !disableClose) {
      onDismiss()
    }
  }

  useKeydownEventListener((event) => {
    if (event && event.key === 'Escape') {
      handleOnDismiss()
    }
  })

  return (
    <StyledAlchemyModal
      data-size={sizeMode === ModalSizeModeEnum.Full ? 'full' : 'auto'}
      className={`alchemy-modal ${className}`}
      sizeMode={sizeMode}
      id={id}
      {...props}
      colorTheme={colorTheme}
    >
      {children}
    </StyledAlchemyModal>
  )
}

const StyledAlchemyModal = styled(Box)<{ colorTheme: keyof typeof modalColors; sizeMode?: ModalSizeModeEnum }>`
  background: ${({ theme, colorTheme }) => theme.modal.colors[colorTheme].background};
  border-radius: ${({ theme }) => theme.radii.extraLarge};
  box-sizing: border-box;
  min-height: 100px;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 100%;
  width: 100%;
  max-width: 512px;

  ${({ sizeMode }) =>
    sizeMode === ModalSizeModeEnum.Full
      ? css`
          border-radius: 0px;
          height: calc(var(--screen-height) * 1);
          max-height: calc(var(--screen-height) * 1);
        `
      : css`
          max-height: calc(var(--screen-height) * 0.95);
        `}

  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 440px;
    max-width: 100%;
  }
`

export default AlchemyModal
